import axios from "axios";
import { deviceId } from "@/lib/device";
import { getAttribution } from "@/lib/utm";
import { consentHeader } from "@/lib/consent";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });
try {
  api.defaults.headers.common["X-Device-Id"] = deviceId();
} catch {}
api.interceptors.request.use((cfg) => {
  cfg.headers["X-Consent"] = consentHeader();
  const a = getAttribution();
  ["utm_source", "utm_campaign", "utm_content"].forEach((k) => {
    if (a?.[k]) cfg.headers[`X-${k.replace("_", "-")}`] = encodeURIComponent(a[k]).slice(0, 200);
  });
  return cfg;
});

export const track = (type, extra = {}) => api.post("/events/track", { type, ...extra }).catch(() => {});

export const errMsg = (e, fallback) => e?.response?.data?.detail?.message || fallback;
export const errCode = (e) => e?.response?.data?.detail?.code;
export const errField = (e) => e?.response?.data?.detail?.field;

export const mapUrl = (radarId, theme, v, w = 640, h = 640) => `${API}/radar/${radarId}/map.png?theme=${theme}&w=${w}&h=${h}${v ? `&v=${v}` : ""}`;

export const fmtRating = (r) =>
  r == null ? "-" : Number(r).toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const rankLabel = (rank) => (!rank || rank > 10 ? "hors top 10" : rank === 1 ? "1re" : `${rank}e`);

export const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export const fmtSession = (iso, short = false) =>
  new Date(iso).toLocaleString("fr-FR", short ? { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" } : { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });

export const isBooked = (user) => ["active", "pending"].includes(user?.access?.booking?.status);
